<template>
  <v-dialog v-model="editDialog" persistent max-width="700px">
    <v-card>
      <form @submit.prevent="validateBeforeSubmit($event)">
        <v-layout row class="no-select" style="background-color:#09132f">
          <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
            <v-layout align-center>
              <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">attach_money</v-icon>
              <span class="px-3">{{ $t(`Edit Cash Transaction's Information`) }}</span>
            </v-layout>
          </h3>
          <v-spacer />
          <v-card-actions>
            <v-btn fab icon dark @click="$emit('hidemodal')">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-layout>

        <v-card-title class="grey lighten-3">
          <v-layout row wrap>
            <v-flex xs6 pa-2>
              <v-autocomplete
                v-model="viewInfo.payer_outlet_id_fk"
                :label="`${$t('Send Outlet')} *`"
                :items="cashList"
                hide-details
                box
                data-vv-name="Send Outlet"
                background-color="white"
                :error="errors.has('Send Outlet')"
                v-validate="'required'"
                @input="setMaxAmount()"
              />
            </v-flex>

            <v-flex xs6 pa-2>
              <v-autocomplete
                v-model="viewInfo.receive_outlet_id_fk"
                :label="`${$t('Receive Outlet')} *`"
                :items="cashList"
                hide-details
                box
                data-vv-name="Receive Outlet"
                background-color="white"
                :error="errors.has('Receive Outlet')"
                v-validate="'required'"
              />
            </v-flex>

            <v-flex xs4 pa-2>
              <v-text-field
                v-model.number="viewInfo.amount_us"
                :label="`${$t('Amount')} (USA) *`"
                name="amount_us"
                box
                :hint="max_amount_us | currency"
                persistent-hint
                background-color="white"
                :error="errors.has('amount_us')"
                v-validate="'required|decimal:3|min_value:0'"
              />
            </v-flex>

            <v-flex xs4 pa-2>
              <v-text-field
                v-model.number="viewInfo.amount_iq"
                :label="`${$t('Amount')} (IQD) *`"
                name="amount_iq"
                box
                :hint="max_amount_iq | currency"
                persistent-hint
                background-color="white"
                :error="errors.has('amount_iq')"
                v-validate="'required|decimal:3|min_value:0'"
              />
            </v-flex>

            <v-flex xs4 pa-2>
              <v-menu v-model="dateMenu" full-width max-width="290" :close-on-content-click="false">
                <v-text-field
                  slot="activator"
                  :value="viewInfo.transaction_date"
                  :label="`${$t('Transaction Date')} *`"
                  prepend-inner-icon="event"
                  box
                  readonly
                  hide-details
                  name="transaction_date"
                  background-color="white"
                  autocomplete="off"
                  :error="errors.has('transaction_date')"
                  v-validate="'required|date_format:yyyy-MM-dd'"
                />
                <v-date-picker @change="dateMenu = false" v-model="viewInfo.transaction_date" />
              </v-menu>
            </v-flex>

            <v-flex xs12 pa-2>
              <v-textarea
                v-model="viewInfo.note"
                :label="$t('Note')"
                name="note"
                box
                hide-details
                height="80"
                background-color="white"
              />
            </v-flex>
          </v-layout>
        </v-card-title>

        <v-divider light />

        <v-card-actions class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="pb-2 px-2" style="color: #444;"
              >- {{ $t('Fields marked with asterisk ( * ) are required.') }}</v-flex
            >

            <v-layout justify-end>
              <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Cancel') }}</v-btn>
              <v-btn type="submit" color="success" :loading="btnUpdateLoading">
                <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">save</v-icon>
                {{ $t('Update') }}
              </v-btn>
            </v-layout>
          </v-layout>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import * as helpers from '@/mixins/helperFunctions.js'

export default {
  name: 'edit-component',

  props: {
    editDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      dateMenu: false,
      btnUpdateLoading: false,
      max_amount_us: 0,
      max_amount_iq: 0
    }
  },

  computed: {
    ...mapGetters({
      viewInfo: 'cashTransactions/getCashTransactionInfo',
      cashList: 'cashTransactions/getCashList'
    })
  },

  watch: {
    editDialog: {
      immediate: false,
      handler() {
        if (this.editDialog) {
          this.addEscKeyListener()
          this.fetchCashList()
          this.setMaxAmount()
        }
      }
    }
  },

  methods: {
    ...mapActions({
      updateCashTransactionInfo: 'cashTransactions/updateCashTransactionInfo',
      fetchCashList: 'cashTransactions/fetchCashList'
    }),

    hasPermissions(permissions) {
      return helpers.userHasPermissions(permissions)
    },

    addEscKeyListener() {
      document.addEventListener('keyup', e => {
        // if the "ESC" button was pressed and this dialog is shown, hide it
        if (e.keyCode === 27 && this.editDialog) {
          this.$emit('hidemodal')
        }
      })
    },

    setMaxAmount() {
      const item = this.cashList.filter(item => item.value === this.viewInfo.payer_outlet_id_fk)[0]
      this.max_amount_us = item.amount_us
      this.max_amount_iq = item.amount_iq
    },

    validateBeforeSubmit(event) {
      this.$validator.validateAll().then(() => {
        if (!this.errors.any()) {
          this.btnUpdateLoading = true

          let formData = new FormData(event.target)
          formData.append('payer_outlet_id_fk', this.viewInfo.payer_outlet_id_fk)
          formData.append('receive_outlet_id_fk', this.viewInfo.receive_outlet_id_fk)

          // for (let pair of formData.entries()) {
          //   console.warn(`${pair[0]}: ${pair[1]}`)
          // }

          let payload = { id: this.viewInfo.cash_transaction_id, formData }

          this.updateCashTransactionInfo(payload)
            .then(() => {
              this.btnUpdateLoading = false
              this.$emit('updated')
            })
            .catch(() => {
              this.btnUpdateLoading = false
            })
        }
      })
    }
  }
}
</script>

<style scoped></style>
